﻿import { IOrderableTreeItem } from "@/components/OrderableTree/interfaces";
import { IMilestoneTemplate } from "@/interfaces";
import _ from "lodash";

export const updateMilestoneTemplateOrderingRecursive = (
  updateMilestone: IOrderableTreeItem<IMilestoneTemplate>,
  reorderedMilestones: IMilestoneTemplate[],
  milestones: IMilestoneTemplate[]
): IMilestoneTemplate[] => {
  const rootLevelMilestonesReordered = !updateMilestone.parentId;

  let updatedMilestones = rootLevelMilestonesReordered
    ? reorderedMilestones
    : _.cloneDeep(milestones);

  const milestoneRemovedFromRootLevel =
    updateMilestone.parentId &&
    milestones.some(({ id }) => updateMilestone.id === id);

  if (milestoneRemovedFromRootLevel)
    updatedMilestones = updatedMilestones.filter(
      ({ id }) => id !== updateMilestone.id
    );

  return updateChildMilestonesRecursive(
    updatedMilestones,
    updateMilestone,
    reorderedMilestones
  );
};

const updateChildMilestonesRecursive = (
  milestones: IMilestoneTemplate[],
  updateMilestone: IOrderableTreeItem<IMilestoneTemplate>,
  reorderedMilestones: IMilestoneTemplate[]
): IMilestoneTemplate[] =>
  milestones.map((milestone) => {
    let { childMilestones } = milestone;

    childMilestones = filterMilestoneFromFormerParent(
      updateMilestone,
      childMilestones
    );

    const childMilestonesReordered = milestone.id === updateMilestone.parentId;

    if (childMilestonesReordered) {
      childMilestones = reorderedMilestones;
    }

    if (childMilestones?.length) {
      childMilestones = updateChildMilestonesRecursive(
        childMilestones,
        updateMilestone,
        reorderedMilestones
      );
    }

    return { ...milestone, childMilestones };
  });

const filterMilestoneFromFormerParent = (
  updatedMilestone: IOrderableTreeItem<IMilestoneTemplate>,
  childMilestones?: IMilestoneTemplate[]
): IMilestoneTemplate[] | undefined => {
  const containsUpdatedMilestone = childMilestones?.some(
    ({ id }) => id === updatedMilestone.id
  );

  return containsUpdatedMilestone
    ? childMilestones?.filter(({ id }) => id !== updatedMilestone.id)
    : childMilestones;
};
